var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.65 25.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#528918;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,17.25c.12-.51.48-.75.45-1.41a15.52,15.52,0,0,0,.93-3.6.66.66,0,0,1,.39-.36A17.74,17.74,0,0,0,1.2,5.19c0-.45.21-.6.09-.75-.06-.36.36-.27.66-.27A8.07,8.07,0,0,0,1.38,2C1.71,1.23,1.71.54,2,0,4.56.78,6.87,2.16,9.09,2.7c3.39,2.43,7.41,4.44,7.68,9.45a3.26,3.26,0,0,0-.18,1.2c-2.76,4.89-9,6.36-14.19,8.82C.18,21.57.21,19.47,0,17.25ZM4.92,5.64a20.17,20.17,0,0,1,.18,9.93c1-.06,1.47-.75,2.7-.84.12-.27.45-.42.63-.63,2-.78,3.9-1.59,4.74-3.54C12.57,9.42,11.22,9,10.65,7.8,9.42,7.59,8.94,6.66,7.59,6.57c0-.12-.12-.12-.09-.27a5.33,5.33,0,0,1-2.22-.75A.64.64,0,0,0,4.92,5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.36,24.33c0,.19-.23.19-.28.34-2.2.34-4.55.93-6.84,1.19,0,0-.1,0-.1-.05A5.45,5.45,0,0,1,19,25.46c-1-.82-.84-2.62-.51-3.58a17.58,17.58,0,0,1,4-4c.49-.58,1.19-.94,1.72-1.47-1.37-.52-3.1.14-4,.33-.35-.15-.9-.12-1.37-.28-.56-.45-.26-1.55-.45-2a5.73,5.73,0,0,1,.51-.86c2.11-.57,5.38-.91,7.29.51a1.48,1.48,0,0,0,1,1.21,4.15,4.15,0,0,1,.53,1.41,6.64,6.64,0,0,1-2.22,2.68c-.46.37-1.05.61-1.44,1-.07.07-.09.26-.17.33-.41.37-1,.61-1.37,1s-.43.58-.73.79c.82.26,1.59-.14,2.57-.11a6.11,6.11,0,0,1,2.27-.4,3.79,3.79,0,0,1,1.87-.35c.32.12.37.51.68.63-.06.24,0,.28,0,.58C30.32,23.38,29,24.73,28.36,24.33Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD2);
export default __webpack_public_path__ + "static/media/D2.12ab7e0f56f1792af29eeabbad886b50.svg";
export { ForwardRef as ReactComponent };